<template>
  <li :class="itemClasses">
    <div :class="tailClasses"></div>
    <div ref="dot" :class="nodeClasses">
      <slot name="dot">
        <i :class="iconClasses"></i>
      </slot>
    </div>
    <div :class="contentClasses">
      <div v-if="time" :class="timeClass" v-html="time"></div>
      <slot name="title">
        <div v-if="title" :class="contentTitleClasses" v-html="title">
        </div>
      </slot>
      <slot>
        <div :class="contentDetailClasses" v-html="detail">
        </div>
      </slot>
    </div>
  </li>
</template>
<script>
import { PREFIX_CLASS } from '@/utils/constants'
const PREFIXCLS = `${PREFIX_CLASS}timeline__item`

export default {
  name: 'TTimelineItem',
  props: {
    color: {
      type: String,
      default: ''
    },
    time: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    detail: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dot: false
    }
  },
  computed: {
    itemClasses() {
      return `${PREFIXCLS}`
    },
    timeClass() {
      return `${PREFIXCLS}-time`
    },
    tailClasses() {
      return `${PREFIXCLS}-tail`
    },
    iconClasses() {
      return `${PREFIXCLS}-icon`
    },
    nodeClasses() {
      return [
        `${PREFIXCLS}-node`,
        {
          [`${PREFIXCLS}-node--custom`]: this.dot,
          [`${PREFIXCLS}-node--${this.color}`]: this.nodeColorShow
        }
      ]
    },
    nodeColorShow() {
      return ['info', 'danger', 'success', 'warning'].includes(this.color)
    },
    contentClasses() {
      return `${PREFIXCLS}-content`
    },
    contentTitleClasses() {
      return [`${PREFIXCLS}-content-title`, 'mb-2']
    },
    contentDetailClasses() {
      return `${PREFIXCLS}-content-detail`
    }
  },
  mounted() {
    this.dot = !!this.$refs.dot.innerHTML.length
  }
}
</script>



// WEBPACK FOOTER //
// src/module/timeline/timeline-item.vue